'use client'

import { forwardRef, useImperativeHandle, useState } from 'react'
import styles from './ua.module.scss'

const Modal = forwardRef((props, ref) => {
  
  const [visible,setVisible] = useState(false)
  
  const show = () => {
    setVisible(true)
  }
  
  const hide = () => {
    setVisible(false)
  }
  
  useImperativeHandle(ref, () => ({
    show, hide
  }))
  
  return (<>
    <div className={ styles.backdrop + ' ' + (visible ? styles.backdropShow : '')} onClick={e => hide()}></div>
    <div className={ styles.modal + ' ' + (visible ? styles.modalShow : '') }>
      { props.children }
    </div>
  </>)
  
})

Modal.displayName = 'Modal';
export default Modal